import { Component } from '@angular/core';

@Component({
  selector: 'app-deployment-not-found',
  templateUrl: './deployment-not-found.component.html',
  styleUrls: ['./deployment-not-found.component.scss'],
})
export class DeploymentNotFoundComponent {}
